// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../graphql/api/index';

import { BlockFragmentDoc } from '../../../components/cms/CmsBlock.fragment.generated';
import { BlockAnchorFragmentDoc } from '../../../components/cms/BlockAnchor.fragment.generated';
import { ComponentFragmentDoc } from '../../../components/cms/CmsComponent.fragment.generated';
import { ComponentsFragmentDoc } from '../../../components/cms/component.generated';
import { ComponentRoundedImageFragmentDoc } from '../../../components/cms/component/ComponentRoundedImage.fragment.generated';
import { CmsImageSizesFragmentDoc } from '../../../components/cms/cmsImageSizes.fragment.generated';
import { ImageCommonFragmentDoc } from '../../../components/cms/imageCommon.fragment.generated';
import { ImageSizeFragmentDoc } from '../../../components/cms/imageSize.fragment.generated';
import { ComponentRoundedImageContentFragmentDoc } from '../../../components/cms/component/ComponentRoundedImageContent.fragment.generated';
import { ContentComponentItemFragmentDoc } from '../../../components/cms/component/ContentComponentItem.fragment.generated';
import { ComponentTitleFragmentDoc } from '../../../components/cms/component/content/ContentTitle.fragment.generated';
import { ComponentTitleComponentFragmentDoc } from '../../../components/cms/component/content/componentTitleComponent.fragment.generated';
import { ComponentTitleAmpersandFragmentDoc } from '../../../components/cms/component/content/componentTitleAmpersand.fragment.generated';
import { ComponentTitleTextFragmentDoc } from '../../../components/cms/component/content/componentTitleText.fragment.generated';
import { ComponentTextFragmentDoc } from '../../../components/cms/component/content/ContentText.fragment.generated';
import { ComponentButtonFragmentDoc } from '../../../components/cms/component/content/ContentButton.fragment.generated';
import { LinkFragmentDoc, LinkItemFragmentDoc, PageLinkFragmentDoc, PostLinkFragmentDoc, CustomLinkFragmentDoc, LinkQuestionnaireFragmentDoc, LinkItemOpenEnquiryFormFragmentDoc, LinkItemErRecommendationsFragmentDoc } from '../../../components/cms/index.generated';
import { ComponentSpacerFragmentDoc } from '../../../components/cms/component/content/ContentSpacer.fragment.generated';
import { ComponentImageFragmentDoc } from '../../../components/cms/component/content/ContentImage.fragment.generated';
import { ComponentOrderedListFragmentDoc } from '../../../components/cms/component/content/ContentOrderedList.fragment.generated';
import { OrderedListItemFragmentDoc } from '../../../components/cms/component/content/orderedListItem.generated';
import { ComponentContentFragmentDoc } from '../../../components/cms/component/ComponentContent.fragment.generated';
import { ComponentCardFragmentDoc } from '../../../components/cms/component/CardComponent.fragment.generated';
import { ComponentTextOverImageFragmentDoc } from '../../../components/cms/component/ComponentTextOverImage.fragment.generated';
import { ComponentCustomProductCarouselFragmentDoc } from '../../../components/cms/component/ComponentCustomProductCarousel.fragment.generated';
import { CustomProductCarouselCardFragmentDoc } from '../../../components/cms/component/carousel/card/CustomProductCarouselCard.fragment.generated';
import { ComponentCatalogueProductCarouselFragmentDoc } from '../../../components/cms/component/ComponentCatalogueProductCarousel.fragment.generated';
import { ProductCardFragmentDoc, ProductCardRingBuilderMountPriceFragmentDoc } from '../../../components/layout/cards/ProductCard.fragment.generated';
import { ProductLinkFragmentDoc } from '../../../router/fragments/productLink.fragment.generated';
import { EngagementRingLinkFragmentDoc } from '../../../router/fragments/engagementRingLink.fragment.generated';
import { JewelleryLinkFragmentDoc } from '../../../router/fragments/jewelleryLink.fragment.generated';
import { ReadyToGoRingLinkFragmentDoc } from '../../../router/fragments/readyToGoRingLink.fragment.generated';
import { WeddingRingLinkFragmentDoc } from '../../../router/fragments/weddingRingLink.fragment.generated';
import { MetalVariationFragmentDoc } from '../../../components/rings/MetalVariations.generated';
import { MetalFilterMetalFragmentDoc } from '../../../graphql/api/product/rings/fragments/filters/metalFilter.fragment.generated';
import { GetIsLabGrownFragmentDoc } from '../../../domain/product/getIsLabGrown.generated';
import { MoneyFragmentDoc } from '../../../graphql/api/fragments/money.fragment.generated';
import { MonolithImageSizeFragmentDoc } from '../../../components/monolithImageSize.fragment.generated';
import { ComponentReviewCarouselFragmentDoc } from '../../../components/cms/component/ComponentReviewCarousel.fragment.generated';
import { ComponentMainCoverFragmentDoc } from '../../../components/cms/component/ComponentMainCover.fragment.generated';
import { VideoFragmentDoc } from '../../../components/cms/video.fragment.generated';
import { ComponentVideoFragmentDoc } from '../../../components/cms/component/ComponentVideo.fragment.generated';
import { ComponentVideoWithContentFragmentDoc } from '../../../components/cms/component/ComponentVideoWithContent.fragment.generated';
import { ComponentInstagramPostsFragmentDoc } from '../../../components/cms/component/ComponentInstagramPosts.fragment.generated';
import { ComponentLogosFragmentDoc } from '../../../components/cms/component/ComponentLogos.fragment.generated';
import { ComponentLogosCarouselFragmentDoc } from '../../../components/cms/component/ComponentLogosCarousel.fragment.generated';
import { ComponentTextWithImageFragmentDoc } from '../../../components/cms/component/ComponentTextWithImage.fragment.generated';
import { ComponentGalleryCarouselFragmentDoc } from '../../../components/cms/component/ComponentGalleryCarousel.fragment.generated';
import { GalleryCarouselCardFragmentDoc } from '../../../components/cms/component/carousel/card/GalleryCarouselCard.fragment.generated';
import { ComponentCardCarouselFragmentDoc } from '../../../components/cms/component/carousel/card/ComponentCardCarousel.fragment.generated';
import { CardCarouselCardFragmentDoc } from '../../../components/cms/component/carousel/card/CardCarouselCard.fragment.generated';
import { ComponentFullWidthImageFragmentDoc } from '../../../components/cms/component/ComponentFullWidthImage.fragment.generated';
import { ComponentSideBySideImagesFragmentDoc } from '../../../components/cms/component/ComponentSideBySideImages.fragment.generated';
import { ComponentSideBySideImageFragmentDoc } from '../../../components/cms/component/side-by-side-images/ComponentSideBySideImage.fragment.generated';
import { ComponentArticlePreviewsFragmentDoc } from '../../../components/cms/component/ComponentArticlePreviews.fragment.generated';
import { ArticlePreviewFragmentDoc } from '../../../components/cms/component/article-previews/ArticlePreview.fragment.generated';
import { ComponentInstagramWithContentFragmentDoc } from '../../../components/cms/component/ComponentInstagramWithContent.fragment.generated';
import { ComponentBannerTitleFragmentDoc } from '../../../components/cms/component/ComponentBannerTitle.fragment.generated';
import { ComponentQuoteFragmentDoc } from '../../../components/cms/component/ComponentQuote.fragment.generated';
import { ComponentBannerSkinnyFragmentDoc } from '../../../components/cms/component/ComponentBannerSkinny.fragment.generated';
import { ComponentGlobalSpacerFragmentDoc } from '../../../components/cms/component/ComponentGlobalSpacer.fragment.generated';
import { ComponentTextWithImageCarouselFragmentDoc } from '../../../components/cms/component/ComponentTextWithImageCarousel.fragment.generated';
import { ComponentContentWithGalleryFragmentDoc } from '../../../components/cms/component/ComponentContentWithGallery.fragment.generated';
import { ComponentIconCarouselFragmentDoc } from '../../../components/cms/component/ComponentIconCarousel.fragment.generated';
import { ComponentTextCarouselFragmentDoc } from '../../../components/cms/component/ComponentTextCarousel.fragment.generated';
import { ComponentFaqFragmentDoc } from '../../../components/cms/component/ComponentFaq.fragment.generated';
import { FaqSectionFragmentDoc } from '../../../components/cms/component/faq/FaqSection.fragment.generated';
import { FaqQuestionFragmentDoc } from '../../../components/cms/component/faq/FaqQuestion.fragment.generated';
import { ComponentContentTwoColumnsFragmentDoc } from '../../../components/cms/component/ComponentContentTwoColumns.fragment.generated';
import { ComponentTableFragmentDoc } from '../../../components/cms/component/ComponentTable.fragment.generated';
import { ComponentArticleGridFragmentDoc } from '../../../components/cms/component/ComponentArticleGrid.fragment.generated';
import { ArticleGridItemFragmentDoc } from '../../../components/cms/component/article-grid/ArticleGridItem.fragment.generated';
import { ComponentOnThisPageFragmentDoc } from '../../../components/cms/component/ComponentOnThisPage.fragment.generated';
import { ComponentGalleryWithEnquiryFragmentDoc } from '../../../components/cms/component/gallery-with-enquiry/componentGalleryWithEnquiry.fragment.generated';
import { GalleryWithEnquiryCardFragmentDoc } from '../../../components/cms/component/gallery-with-enquiry/galleryWithEnquiryCard.fragment.generated';
import { ComponentSquareBoxesFragmentDoc } from '../../../components/cms/component/square-boxes/ComponentSquareBoxes.fragment.generated';
import { SquareBoxesFragmentDoc } from '../../../components/cms/component/square-boxes/squareBoxes.fragment.generated';
import { SquareTextBoxFragmentDoc } from '../../../components/cms/component/square-boxes/SquareTextBox.fragment.generated';
import { SquareImageBoxFragmentDoc } from '../../../components/cms/component/square-boxes/SquareImageBox.fragment.generated';
import { ComponentShopWithConfidenceFragmentDoc, ShopWithConfidenceProductFragmentDoc } from '../../../components/cms/component/ComponentShopWithConfidence.generated';
import { ComponentWarrantyActivationFormFragmentDoc } from '../../../components/cms/component/ComponentWarrantyActivationForm.fragment.generated';
import { ComponentJobsFragmentDoc } from '../../../components/cms/component/ComponentJobs.fragment.generated';
import { ComponentJobsJobFragmentDoc } from '../../../components/cms/component/ComponentJobsJob.fragment.generated';
import { ComponentLogosWithTextFragmentDoc, LogoWithTextFragmentDoc } from '../../../components/cms/component/ComponentLogosWithText.fragment.generated';
import { ComponentGlobalComponentFragmentDoc } from '../../../components/cms/component/ComponentGlobalComponent.fragment.generated';
import { MetaFragmentDoc } from '../../../graphql/api/fragments/meta.fragment.generated';
import { PageTooltipFragmentDoc } from '../../../components/layout/tooltip/PageTooltip.fragment.generated';
import { TooltipFragmentDoc } from '../../../directives/tooltip/tooltip.generated';
import { PdpAccordionItemFragmentDoc } from '../../../components/product/PdpAccordion.generated';
import { CtaBoxFragmentDoc } from '../components/CtaBox.generated';
import { JewelleryFragmentDoc } from '../../../graphql/api/product/rings/jewellery/jewellery.fragment.generated';
import { CatalogueProductFragmentDoc } from '../../../graphql/api/product/catalogueProduct.fragment.generated';
import { RelatedProductFragmentDoc } from '../../../components/rings/RelatedProducts.generated';
import { ProductGalleryFragmentDoc } from '../../../components/layout/gallery/ProductGallery.fragment.generated';
import { ThreeSixtyFragmentDoc } from '../../../components/layout/three-sixty/ThreeSixty.fragment.generated';
import { CatalogueVideoFragmentDoc } from '../../../graphql/api/product/catalogueVideo.fragment.generated';
import { ProductAnalyticsFragmentDoc } from '../composables/analytics/useProductAnalytics.generated';
import { ProductPageMetaFragmentDoc } from '../composables/useProductPageMeta.generated';
import { AssetFragmentDoc } from '../../../graphql/api/fragments/asset.fragment.generated';
import { JewelleryDesignStyleLabelFragmentDoc, JewelleryNecklaceProductStyleLabelFragmentDoc, JewelleryEarringsProductStyleLabelFragmentDoc, JewelleryBraceletProductStyleLabelFragmentDoc, JewelleryRingProductStyleLabelFragmentDoc } from './Jewelleries.generated';
import { FacetedContentProductLabelTranslationFragmentDoc } from '../../../domain/product/useFacetedContent.generated';
import { TaxSnippetFragmentDoc } from '../../../components/rings/TaxSnippet.generated';
import { DeliveryTimeframeFragmentDoc } from '../../../components/rings/DeliveryTimeframe.generated';
import { RingSizeFragmentDoc } from '../../../graphql/api/product/rings/fragments/ringSize.fragment.generated';
import { RecommendedRingSizeFragmentDoc } from '../../../graphql/api/product/rings/fragments/recommendedRingSize.fragment.generated';
import { AffirmFinanceOptionsFragmentDoc } from '../../../graphql/api/checkout/payment/affirmFinanceOptions.fragment.generated';
import { ReviewsFragmentDoc } from '../../../components/rings/reviews.fragment.generated';
import { ReviewsAggregateFragmentDoc } from '../../../components/rings/ReviewsAggregate.generated';
import * as Urql from '@/graphql/urql.ts';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export const JewelleryDetailsFragmentDoc = `
    fragment jewelleryDetails on CatalogueJewellery {
  ...jewellery
  ...jewelleryLink
  ...shopWithConfidenceProduct
  ... on CatalogueJewelleryRing {
    isResizeable
  }
  financeOptionsAffirm(currency: $currency, country: $country) {
    ...affirmFinanceOptions
  }
  reviews {
    ...reviews
  }
  reviewsAggregate {
    ...reviewsAggregate
  }
}
    `;
export const JewelleryDetailsDocument = `
    query jewelleryDetails($slug: String!, $metal: MetalCode!, $suffixSlug: String, $locale: Locale!, $country: CountryCode!, $currency: CurrencyInput!, $page: String!, $pageFallback: String!, $type: CatalogueJewelleryType!) {
  catalogueJewellery(
    filter: {slug: $slug, suffixSlug: $suffixSlug, primaryMetalCode: $metal}
    type: $type
  ) {
    ...jewelleryDetails
  }
  pageProductDetails(path: $page, fallback: $pageFallback, locale: $locale) {
    id
    blocks {
      ...block
    }
    meta {
      ...meta
    }
    priceExplainedTooltip {
      ...pageTooltip
    }
    accordionItems {
      ...pdpAccordionItem
    }
    ...ctaBox
  }
}
    ${JewelleryDetailsFragmentDoc}
${JewelleryFragmentDoc}
${CatalogueProductFragmentDoc}
${RelatedProductFragmentDoc}
${ProductCardFragmentDoc}
${ProductLinkFragmentDoc}
${EngagementRingLinkFragmentDoc}
${JewelleryLinkFragmentDoc}
${ReadyToGoRingLinkFragmentDoc}
${WeddingRingLinkFragmentDoc}
${MetalVariationFragmentDoc}
${MetalFilterMetalFragmentDoc}
${GetIsLabGrownFragmentDoc}
${MoneyFragmentDoc}
${MonolithImageSizeFragmentDoc}
${ProductCardRingBuilderMountPriceFragmentDoc}
${ProductGalleryFragmentDoc}
${ThreeSixtyFragmentDoc}
${CatalogueVideoFragmentDoc}
${ProductAnalyticsFragmentDoc}
${ProductPageMetaFragmentDoc}
${AssetFragmentDoc}
${JewelleryDesignStyleLabelFragmentDoc}
${FacetedContentProductLabelTranslationFragmentDoc}
${TaxSnippetFragmentDoc}
${JewelleryNecklaceProductStyleLabelFragmentDoc}
${DeliveryTimeframeFragmentDoc}
${JewelleryEarringsProductStyleLabelFragmentDoc}
${JewelleryBraceletProductStyleLabelFragmentDoc}
${JewelleryRingProductStyleLabelFragmentDoc}
${RingSizeFragmentDoc}
${RecommendedRingSizeFragmentDoc}
${ShopWithConfidenceProductFragmentDoc}
${AffirmFinanceOptionsFragmentDoc}
${ReviewsFragmentDoc}
${ReviewsAggregateFragmentDoc}
${BlockFragmentDoc}
${BlockAnchorFragmentDoc}
${ComponentFragmentDoc}
${ComponentsFragmentDoc}
${ComponentRoundedImageFragmentDoc}
${CmsImageSizesFragmentDoc}
${ImageCommonFragmentDoc}
${ImageSizeFragmentDoc}
${ComponentRoundedImageContentFragmentDoc}
${ContentComponentItemFragmentDoc}
${ComponentTitleFragmentDoc}
${ComponentTitleComponentFragmentDoc}
${ComponentTitleAmpersandFragmentDoc}
${ComponentTitleTextFragmentDoc}
${ComponentTextFragmentDoc}
${ComponentButtonFragmentDoc}
${LinkFragmentDoc}
${LinkItemFragmentDoc}
${PageLinkFragmentDoc}
${PostLinkFragmentDoc}
${CustomLinkFragmentDoc}
${LinkQuestionnaireFragmentDoc}
${LinkItemOpenEnquiryFormFragmentDoc}
${LinkItemErRecommendationsFragmentDoc}
${ComponentSpacerFragmentDoc}
${ComponentImageFragmentDoc}
${ComponentOrderedListFragmentDoc}
${OrderedListItemFragmentDoc}
${ComponentContentFragmentDoc}
${ComponentCardFragmentDoc}
${ComponentTextOverImageFragmentDoc}
${ComponentCustomProductCarouselFragmentDoc}
${CustomProductCarouselCardFragmentDoc}
${ComponentCatalogueProductCarouselFragmentDoc}
${ComponentReviewCarouselFragmentDoc}
${ComponentMainCoverFragmentDoc}
${VideoFragmentDoc}
${ComponentVideoFragmentDoc}
${ComponentVideoWithContentFragmentDoc}
${ComponentInstagramPostsFragmentDoc}
${ComponentLogosFragmentDoc}
${ComponentLogosCarouselFragmentDoc}
${ComponentTextWithImageFragmentDoc}
${ComponentGalleryCarouselFragmentDoc}
${GalleryCarouselCardFragmentDoc}
${ComponentCardCarouselFragmentDoc}
${CardCarouselCardFragmentDoc}
${ComponentFullWidthImageFragmentDoc}
${ComponentSideBySideImagesFragmentDoc}
${ComponentSideBySideImageFragmentDoc}
${ComponentArticlePreviewsFragmentDoc}
${ArticlePreviewFragmentDoc}
${ComponentInstagramWithContentFragmentDoc}
${ComponentBannerTitleFragmentDoc}
${ComponentQuoteFragmentDoc}
${ComponentBannerSkinnyFragmentDoc}
${ComponentGlobalSpacerFragmentDoc}
${ComponentTextWithImageCarouselFragmentDoc}
${ComponentContentWithGalleryFragmentDoc}
${ComponentIconCarouselFragmentDoc}
${ComponentTextCarouselFragmentDoc}
${ComponentFaqFragmentDoc}
${FaqSectionFragmentDoc}
${FaqQuestionFragmentDoc}
${ComponentContentTwoColumnsFragmentDoc}
${ComponentTableFragmentDoc}
${ComponentArticleGridFragmentDoc}
${ArticleGridItemFragmentDoc}
${ComponentOnThisPageFragmentDoc}
${ComponentGalleryWithEnquiryFragmentDoc}
${GalleryWithEnquiryCardFragmentDoc}
${ComponentSquareBoxesFragmentDoc}
${SquareBoxesFragmentDoc}
${SquareTextBoxFragmentDoc}
${SquareImageBoxFragmentDoc}
${ComponentShopWithConfidenceFragmentDoc}
${ComponentWarrantyActivationFormFragmentDoc}
${ComponentJobsFragmentDoc}
${ComponentJobsJobFragmentDoc}
${ComponentLogosWithTextFragmentDoc}
${LogoWithTextFragmentDoc}
${ComponentGlobalComponentFragmentDoc}
${MetaFragmentDoc}
${PageTooltipFragmentDoc}
${TooltipFragmentDoc}
${PdpAccordionItemFragmentDoc}
${CtaBoxFragmentDoc}`;

export function useJewelleryDetailsQuery(options?: Omit<Urql.UseQueryArgs<never, SchemaTypes.JewelleryDetailsQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<SchemaTypes.JewelleryDetailsQuery, SchemaTypes.JewelleryDetailsQueryVariables | undefined>({ query: JewelleryDetailsDocument, variables: undefined, ...options });
};